export function useAccessToken() {


    let params = new URL(window.location.href);
    var value = params.searchParams.get('accessToken')

    return {
        value,
    }

}